<div class="banking-information-form">
    <div class="signio-divider-header" @click="toggle('bank_details')">
      <span class="chevron">{{ collapsed_sections.bank_details ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Bank Account Details</label>
    </div>
    <transition name="fade">
      <div v-show="!collapsed_sections.bank_details">
        <div class="form-group my-2">
          <label for="customer-bank" class="text-xs required">Bank Name</label>
          <select id="customer-bank-account-bank" class="form-select" v-model="form_data.customerBankAccountBank" @change="update_bank_details">
            <option value="" disabled selected>Select Bank</option>
            <option v-for="(bank, index) in bank_list" :key="index" :value="bank">{{ bank }}</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label for="account-holder" class="text-xs required">Account Holder Name (Given Names and Surname)</label>
          <input type="text" id="customer-bank-account-holder" class="form-control" v-model="form_data.customerBankAccountHolder" placeholder="Enter account holder name" />
        </div>
        <div class="form-group my-2">
          <label for="account-number" class="text-xs required">Account Number</label>
          <input @input="allow_num" type="text" id="customer-bank-account-number" class="form-control" v-model="form_data.customerBankAccountNumber" placeholder="Enter account number" />
        </div>
        <div class="form-group my-2">
          <label for="account-type" class="text-xs required">Account Type</label>
          <select id="customer-bank-account-type" class="form-select" v-model="form_data.customerBankAccountType">
            <option value="" disabled selected>Select Account Type</option>
            <option v-for="type in account_types" :key="type" :value="type">{{ type }}</option>
          </select>
        </div>
      </div>
    </transition>

    <div class="signio-divider-header mt-4" @click="toggle('payment_info')">
      <span class="chevron">{{ collapsed_sections.payment_info ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Payment Information</label>
    </div>
    <transition name="fade">
      <div v-show="!collapsed_sections.payment_info">
        <div class="form-group my-2">
          <label for="salary-day" class="text-xs required">Payment Date (Day of Month)</label>
          <select id="customer-salary-day" class="form-select" v-model="form_data.customerSalaryDay">
            <option value="" disabled selected>Select Day</option>
            <option v-for="day in days_list" :key="day" :value="day">{{ day }}</option>
          </select>
        </div>
      </div>
    </transition>
    <!-- Submit button -->
    <div class="text-end mt-4">
      <button type="button" @click="previous" class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1">
        Previous
      </button>
      <button type="button" @click="submit_section" class="btn btn-bg-green text-xs rounded-small shadow-sm">
        Continue
      </button>
    </div>
  </div>